<template>
	<div class="alert">
		<rp-sprite :name="icon" v-if="icon" :class="type"/>
		<span class="alert-message" v-html="message"/>
		<rp-button type="primary" @click="onClick">{{ this.btnContinueMessage ? this.btnContinueMessage : "continue" }}</rp-button>
	</div>
</template>

<script>
import Button from './inputs/Button'
import Sprite from './Sprite'

export default {
	props: {
		icon: {type: String},
		message: {type: String},
		btnContinueMessage: {type: String},
		onClick: {type: Function},
		type: {type: String}
	},

	components: {
		'rp-button': Button,
		'rp-sprite': Sprite
	}
}
</script>

<style lang="sass" scoped>
	@import '../../styles/base/variables'
	@import '../../styles/helpers/mixins'

	.alert
		display: flex
		align-items: center
		justify-content: space-between
		max-width: 500px
		margin: 0 auto
		padding: 20px
		border-radius: 2px
		background: $color-panel-bg
		box-shadow: 2px 3px 5px 0px $color-shadow

		.sprite
			width: 30px
			height: 30px
			fill: $color-primary

			&.error
				fill: $color-error
		
		.alert-message 
			width: 65%
			padding: 0 20px
			font-size: 12px
		
		button
			margin-top: 0
			color: #fff !important
		
</style>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/Alert.vue